<template>
    <div>
        <label for="pago">Condición Pago</label>
        <select @input="$emit('input', $event.target.value )" required="required" name="pago" id="pago">
            <option :value="dato.name" v-for="(dato, index) in pagos" :key="index">{{dato.name}}</option>
        </select>
        <i class="bar"></i>
    </div>
</template>
<script>
export default {
 name: "CondicionPago",
 data(){
  return{
    pagos:[
           {value: '', name:''},
           {value: '0', name:'Pago Efectivo'},
           {value: '1', name:'Pago Credito'}

        ]
  }
 }
}
</script>

<style scoped>
    label {
        font-weight: bold;
    }
    select {
        margin-top: 8px;
        cursor: pointer;
    }
</style>
